import React, { useCallback } from 'react'
import View from './Home.view'
import { HomeProps, HomeViewProps } from './Home.types'
import { useHistory } from 'react-router-dom'
import ROUTES from 'core/modules/router'
import { useAllGalleryDrops, useAllHighlightDrops } from 'context/Gallery'
import useElementFit from '@onepercentio/one-ui/hooks/useElementFit'

export default function HomeLogic(props: HomeProps) {
  const history = useHistory()
  const onSeeAll = useCallback<HomeViewProps['onSeeAll']>((type) => {
    switch (type) {
      case 'gallery':
        history.push(ROUTES.unauthenticated.allGalleries)
        break
      case 'drops':
        history.push(ROUTES.unauthenticated.marketplace)
        break
    }
  }, [])
  const { ref, anItemMore } = useElementFit(302 + 26)
  const galleriesDrops = useAllGalleryDrops(anItemMore!)
  const highlightedDrops = useAllHighlightDrops(anItemMore!)

  return (
    <View
      onSeeAll={onSeeAll}
      dropsPaginable={galleriesDrops}
      dropsContainerRef={ref}
      highlightsPaginable={highlightedDrops}
    />
  )
}
